import React from "react";
import Pdf from "./Pdf";
import { PDFViewer } from "@react-pdf/renderer";

const PdfPreview = () => (
  <PDFViewer height={"1000"} width={"100%"}>
    <Pdf />
  </PDFViewer>
);

export default PdfPreview;
